import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";
import { baseUrl } from "@/lib/api/base-url";

export const authClient = createAuthClient({
  baseURL: baseUrl,
  plugins: [magicLinkClient()],
});

export const { signIn, signOut, useSession } = authClient;
